import request from '@/utils/request'

let HomepopupApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._get('/shop/plus.homepopup/index', data, errorback);
  },
  /*保存数据*/
  saveData(data, errorback) {
    return request._post('/shop/plus.homepopup/index', data, errorback);
  },
}
export default HomepopupApi;



// WEBPACK FOOTER //
// ./src/api/homepopup.js